import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

export default function UserPerformance({ tickets, users = [], isLoading }) {
  // Função auxiliar para obter o nome do usuário pelo ID
  const getUserName = (userId) => {
    if (!userId) return 'Não atribuído';
    const user = users.find(u => u.id === userId);
    return user ? user.name : userId;
  };

  // Processar dados para o gráfico
  const getUserPerformanceData = () => {
    // Se não houver tickets, retornar array vazio
    if (!tickets || tickets.length === 0) {
      return [];
    }
    
    const ticketsByUser = {};
    
    tickets.forEach(ticket => {
      const assignedTo = ticket.assigned_to || 'Não atribuído';
      
      if (!ticketsByUser[assignedTo]) {
        ticketsByUser[assignedTo] = { resolved: 0, pending: 0 };
      }
      
      if (ticket.status === 'resolved' || ticket.status === 'closed') {
        ticketsByUser[assignedTo].resolved += 1;
      } else {
        ticketsByUser[assignedTo].pending += 1;
      }
    });
    
    return Object.entries(ticketsByUser)
      .filter(([name]) => name !== 'Não atribuído') // Filtrar tickets não atribuídos
      .map(([userId, counts]) => ({
        name: getUserName(userId),
        resolved: counts.resolved,
        pending: counts.pending
      }))
      .sort((a, b) => (b.resolved + b.pending) - (a.resolved + a.pending)); // Ordenar por total de tickets
  };
  
  const data = getUserPerformanceData();
  
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }
  
  if (data.length === 0) {
    return (
      <div className="flex items-center justify-center h-64 text-muted-foreground">
        <div className="text-center">
          <p>Nenhum ticket atribuído encontrado</p>
          <p className="text-sm mt-1">Dados aparecerão quando tickets forem atribuídos</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="h-64">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{ top: 5, right: 30, left: 5, bottom: 5 }}
          layout="vertical"
        >
          <CartesianGrid strokeDasharray="3 3" horizontal={false} />
          <XAxis type="number" />
          <YAxis dataKey="name" type="category" width={70} />
          <Tooltip />
          <Bar dataKey="resolved" name="Resolvidos" fill="#10B981" stackId="a" />
          <Bar dataKey="pending" name="Pendentes" fill="#FBBF24" stackId="a" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}